export enum FieldValueType {
  CIRCUMSTANCES = 'circumstances',
  CORRECTIVE_ACTION_TYPES = 'correctiveActionTypes',
  DECISIONS_TO_IMPOSE_FINE = 'decisionsToImposeFine',
  DELAY_REASONS = 'delayReasons',
  EFFECTS = 'effects',
  ENVIRONMENTAL_ASPECTS = 'environmentalAspects',
  HAZARD_CATEGORIES = 'hazardCategories',
  IMPACTS = 'impacts',
  ISSUE_VERIFICATION_ITEMS = 'issueVerificationItems',
  REJECTION_REASONS = 'rejectionReasons',
  ROOT_CAUSES = 'rootCauses',
  SPILLED_SUBSTANCES = 'spilledSubstances',
  WORKTYPES = 'worktypes',
  PRIORITIES = 'priorities',
  PROJECT_STAGES = 'projectStages',
  EMPLOYMENT_TYPES = 'employmentTypes',
  INJURY_TYPES = 'injuryTypes',
  INJURED_BODY_PARTS = 'injuredBodyParts',
  REQUIREMENTS = 'requirements',
  INSTALLATION_BASIS = 'installationBasis',
  CONSTRUCTION_PRODUCT_DOCUMENTS = 'constructionProductDocuments',
  DEVICE_DOCUMENTS = 'deviceDocuments',
  ADDITIONAL_DOCUMENTS = 'additionalDocuments',
}

export interface FieldValueConfig {
  endpoint: string;
  tableName: string;
  responseType: 'items' | 'data';
}

export const FIELD_VALUES_CONFIG: Record<
  FieldValueType,
  FieldValueConfig
> = {
  [FieldValueType.CIRCUMSTANCES]: {
    endpoint: 'circumstance',
    tableName: 'circumstances',
    responseType: 'items',
  },
  [FieldValueType.CORRECTIVE_ACTION_TYPES]: {
    endpoint: 'correctiveAction',
    tableName: 'correctiveActionTypes',
    responseType: 'items',
  },
  [FieldValueType.DECISIONS_TO_IMPOSE_FINE]: {
    endpoint: 'decisionToImposeFine',
    tableName: 'decisionsToImposeFine',
    responseType: 'items',
  },
  [FieldValueType.DELAY_REASONS]: {
    endpoint: 'delayReason',
    tableName: 'delayReasons',
    responseType: 'items',
  },
  [FieldValueType.EFFECTS]: {
    endpoint: 'effect',
    tableName: 'effects',
    responseType: 'items',
  },
  [FieldValueType.ENVIRONMENTAL_ASPECTS]: {
    endpoint: 'environmentalAspect',
    tableName: 'environmentalAspects',
    responseType: 'items',
  },
  [FieldValueType.HAZARD_CATEGORIES]: {
    endpoint: 'hazardCategory',
    tableName: 'hazardCategories',
    responseType: 'items',
  },
  [FieldValueType.IMPACTS]: {
    endpoint: 'impact',
    tableName: 'impacts',
    responseType: 'items',
  },
  [FieldValueType.ISSUE_VERIFICATION_ITEMS]: {
    endpoint: 'issueVerification',
    tableName: 'issueVerificationItems',
    responseType: 'items',
  },
  [FieldValueType.REJECTION_REASONS]: {
    endpoint: 'rejectionReason',
    tableName: 'rejectionReasons',
    responseType: 'items',
  },
  [FieldValueType.ROOT_CAUSES]: {
    endpoint: 'rootCause',
    tableName: 'rootCauses',
    responseType: 'items',
  },
  [FieldValueType.SPILLED_SUBSTANCES]: {
    endpoint: 'spilledSubstance',
    tableName: 'spilledSubstances',
    responseType: 'items',
  },
  [FieldValueType.WORKTYPES]: {
    endpoint: 'worktype',
    tableName: 'worktypes',
    responseType: 'items',
  },
  [FieldValueType.PRIORITIES]: {
    endpoint: 'priority',
    tableName: 'priorities',
    responseType: 'items',
  },
  [FieldValueType.PROJECT_STAGES]: {
    endpoint: 'projectStage',
    tableName: 'projectStages',
    responseType: 'items',
  },
  [FieldValueType.EMPLOYMENT_TYPES]: {
    endpoint: 'employmentType',
    tableName: 'employmentTypes',
    responseType: 'items',
  },
  [FieldValueType.INJURY_TYPES]: {
    endpoint: 'injuryType',
    tableName: 'injuryTypes',
    responseType: 'items',
  },
  [FieldValueType.INJURED_BODY_PARTS]: {
    endpoint: 'injuredBodyPart',
    tableName: 'injuredBodyParts',
    responseType: 'items',
  },
  [FieldValueType.REQUIREMENTS]: {
    endpoint: 'requirements',
    tableName: 'requirements',
    responseType: 'items',
  },
  [FieldValueType.INSTALLATION_BASIS]: {
    endpoint: 'installationBasis',
    tableName: 'installationBasis',
    responseType: 'items',
  },
  [FieldValueType.CONSTRUCTION_PRODUCT_DOCUMENTS]: {
    endpoint: 'constructionProductDocuments',
    tableName: 'constructionProductDocuments',
    responseType: 'items',
  },
  [FieldValueType.DEVICE_DOCUMENTS]: {
    endpoint: 'deviceDocuments',
    tableName: 'deviceDocuments',
    responseType: 'items',
  },
  [FieldValueType.ADDITIONAL_DOCUMENTS]: {
    endpoint: 'additionalDocuments',
    tableName: 'additionalDocuments',
    responseType: 'items',
  },
};
